import {EmailCredentials} from "./LoginWithEmailForm";
import {toAccountsError} from "../../firebase/errors";
import {signInWithEmailPassword} from "../../firebase";
import {User} from "../auth/types";
import {useAuth} from "../auth/AuthContext";
import {useState} from "react";

export type TranslationKey = {
  key: string
}

export type AccountsError = {
  i18nKey: TranslationKey
  firebaseCode?: string
}

export type LoginWithEmailFn = (values: EmailCredentials) => Promise<void>

export type LoginWithEmailReturn  = {
  loginWithEmail: LoginWithEmailFn
  user?: User
}

/*
  * This is a custom hook that returns a function to login with email and password
  * and a user object with the user has just logged in.
  * The user is returned from the auth context when it matches the user that just logged in.
  * This prevents a race condition where the user has signed in but onIdTokenChanged has not yet been called.
 */
export const useLoginWithEmail = (): LoginWithEmailReturn => {
  const [userId, setUserId] = useState<string>();
  const {user} = useAuth();
  let theUserThatJustSignedIn = undefined;
  if (user && user.uid === userId) {
    theUserThatJustSignedIn = user;
  }
  return {
    loginWithEmail: async (values: EmailCredentials) => {
      setUserId(undefined);
      await signInWithEmailPassword(values.email, values.password)
      .then(firebaseCredentials => setUserId(firebaseCredentials.user?.uid))
      .catch(firebaseErr => Promise.reject(toAccountsError(firebaseErr, "loginError")));
    },
    user: theUserThatJustSignedIn
  }
};